import React, { useEffect, useState } from "react";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { Link, useLocation, useParams } from "react-router-dom";
import DashboardLayouts from "../../Components/Layout/DashboardLayouts";

import axios from "axios";
import { toNumber } from "lodash";
import moment from "moment";
import { AiFillCloseCircle } from "react-icons/ai";
import { BsArrowLeft } from "react-icons/bs";
import { FaEye, FaPen, FaSearch } from "react-icons/fa";
import Loader from "../../Components/Global/Loader";
import { useAuth } from "../../Context/AuthContext";
import useAuthentication from "../../hooks/useAuthentication";
import useAxiosFetch from "../../hooks/useAxiosFetch";
import useSearchListPagination from "../../hooks/useSearchListPagination";
import DummyImg from "../../Public/Images/568165.png";

const fieldNameData = [
  {
    id: "worker",
    value: ["Sl No.", "Task", "Deadline", "Priority", "Status", "Action"],
  },

  {
    id: "manager",
    value: [
      "Sl No.",
      "Building Name",
      "Building Address",
      "Description",
      "Status",
      "Action",
    ],
  },
];
const fieldValueData = [
  {
    id: "worker",
    value: ["task_title", "deadline", "priority", "receiver_status"],
  },

  {
    id: "manager",
    value: ["building_name", "fullAddress", "Description", "status"],
  },
  {
    id: "partner",
    value: ["fullName", "fullAddress", "phone_number", "No. of Building"],
  },
  {
    id: "tenant",
    value: ["fullName", "fullAddress", "phone_number", "No. of Building"],
  },
  {
    id: "manager",
    value: ["fullName", "fullAddress", "phone_number", "No. of Building"],
  },
];

export default function DetailsProfileGlobal({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);
  const { designation } = useAuth();
  const [profileData, setProfileData] = useState({});
  // api api from global hook 

  const { axiosFetch} = useAxiosFetch();
// search and list api call
  const {
    setisKeyPress,
    Count,
    setCount,
    setsearchKey,
    searchKey,
    setRecord,
    record,
    setPages,
    pages,
    totallength,
    paginationLoading,
    handleNextbtn,
    handlePrevbtn,
    PageShowFunc,
    setTotallength,
    SearchListApi,
    allData,
  } = useSearchListPagination();

  const location = useLocation();
  const pathname = location.pathname;
  const [makeUrl, setMakeUrl] = useState({
    navigateUrl: "",
    apiUrl: "",
  });
  const [errorMessage, setErrorMessage] = useState();
  const [buildingSearch, setSearchBuilding] = useState("");
  const [tableNameData, setTableNameData] = useState([]);
  const [tableValueData, setTableValueData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModal, setIsmodal] = useState(false);
  const [buildingAssign, setBuildingAssign] = useState();
  const [selectbuilding, setSelectbuilding] = useState();
  const [buildingData, setBuildingData] = useState({});
  const [getbuildingvalue, setGetbuildingvalue] = useState();
  const [showListData, setshowListData] = useState([]);

  const value = useParams();
  const managerId = value.id;
  const { id: profileId } = useParams();

//get the profile description

  useEffect(() => {
    if (pathname.includes("partner")) {
      setMakeUrl({ apiUrl: "partner", navigateUrl: "/partnerlist" });
    }
    if (pathname.includes("manager")) {
      setMakeUrl({ apiUrl: "manager", navigateUrl: "/managerlist" });
    }
    if (pathname.includes("accountant")) {
      setMakeUrl({ apiUrl: "accountant", navigateUrl: "/accountantlist" });
    }
    if (pathname.includes("worker")) {
      setMakeUrl({ apiUrl: "worker", navigateUrl: "/workerlist" });
    }
    if (pathname.includes("tenant")) {
      setMakeUrl({ apiUrl: "tenant", navigateUrl: "/tenantlist" });
    }
    if (pathname.includes("owner")) {
      setMakeUrl({ apiUrl: "owner", navigateUrl: "/ownerlist" });
    }
  }, [pathname]);

//set  table header

  useEffect(() => {
    setTableNameData(
      makeUrl.apiUrl == "worker" && designation !== "Admin"
        ? fieldNameData.find((f) => f.id == makeUrl.apiUrl)?.value
        : fieldNameData.find((f) => f.id == makeUrl.apiUrl)?.value?.slice(0, -1)
    );
    setTableValueData(
      fieldValueData.find((f) => f.id == makeUrl.apiUrl)?.value
    );
  }, [makeUrl, designation]);

//Building assign for manager


  const BuildingAssignFunc = () => {
    if (selectbuilding?.length !== 0) {
      setLoading(true);
      axios
        .post("/manager/BuildingAssign", {
          manager_id: managerId,
          Building_Assigns: selectbuilding,
        })
        .then((res) => {
          if (res?.data) {
            setBuildingData(res?.data?.building);
            setLoading(false);
            managerAssignBuilding();
            setIsmodal(false);
            setErrorMessage("");
          }
        })
        .catch((e) => {
          setLoading(false);
        });
    } else {
      setErrorMessage("please choose atleast one building");
    }
  };
  const managerAssignBuilding = () => {
    setLoading(true);
    axios
      .post(`/manager/Building/Assign/${managerId}`, {
        page: pages,
        record: record,
      })
      .then((response) => {
        if (response?.data?.result?.count >= 0) {
          setCount(response?.data?.result?.count);
          setBuildingAssign(response.data.result.rows);
          SearchListFunc();
        }
        if (response?.data?.totallength >= 0) {
          let pageNo = response.data.totallength;
          let pagelist = [];

          for (let i = 0; i < pageNo; i++) {
            pagelist.push(i + 1);
          }
          setTotallength(pagelist);
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const BuildingAssignData = (e) => {
    let buildingassign_array = [...selectbuilding];
    if (e.target.checked) {
      buildingassign_array = [...selectbuilding, toNumber(e.target.value)];
      setSelectbuilding(buildingassign_array);
    } else {
      let buildingAssign1 = buildingassign_array.indexOf(e.target.value);
      if (buildingAssign1 !== 1) {
        buildingassign_array.splice(buildingAssign1, 1);
        setSelectbuilding(buildingassign_array);
      }
    }
  };
  const SearchBuilding = () => {
    axios
      .post(`/search`, {
        building_modal_name: buildingSearch,
      })
      .then((res) => {
        if (res?.data) {
          setBuildingData(res?.data?.building);
        }
      });
  };

  const SearchListFunc = () => {
    setLoading(true);
    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `/building/modal/list`,
    })
      .then((res) => {
        if (res?.data) {
          setBuildingData(res?.data?.building);
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };



//get profile data from database

  const getProfileDetails = () => {
    axios
      .get(`/${makeUrl.apiUrl}/show/${profileId}`)
      .then((response) => {
        setBuildingAssign(response?.data?.AssignBuildings);
        setProfileData(response?.data);
      })
      .catch((e) => {});
  };
  useEffect(() => {
    if (makeUrl.apiUrl) {
      getProfileDetails();
    }
  }, [profileId, makeUrl]);

  const source = axios.CancelToken.source();
  useEffect(() => {
    if (makeUrl.apiUrl == "worker") {
      SearchListApi(`/task`, { worker_id: profileId }, source);
    }
    if (makeUrl.apiUrl == "manager") {
      SearchListApi(`/building`, { manager_id: profileId }, source);
    }
    return () => source.cancel();
  }, [searchKey, record, pages, makeUrl, profileId]);

  useEffect(() => {
    setshowListData(
      allData?.map((data, i) => {
        return {
          ...data,
          fullAddress: `${data?.address ? data?.address : ""} ${
            data?.address ? "," : ""
          } ${data?.street_address ? data?.street_address.slice(0, 45) : ""}  ${
            data?.street_address ? "," : ""
          } ${data?.apartment ? data?.apartment : ""} ${
            data?.apartment ? "," : ""
          } ${data?.country_name ? data?.country_name : ""} ${
            data?.country_name ? "," : ""
          } ${data?.postal_code ? data?.postal_code : ""}`,
        };
      })
    );
  }, [allData, designation]);

  return (
    <>
      <DashboardLayouts>
        {(loading || allowLoading) && <Loader />}
        <div className="breadcrumb row justify-content-between align-items-center">
          <div className="back-link dashboard-upper-menu col-md-4 col-auto">
            <Link
              to={
                designation === "Owner" || designation === "Partner"
                  ? "/dashboard"
                  : `/${designation}dashboard`.toLowerCase()
              }
              className="d-flex align-items-center back-link"
            >
              <BsArrowLeft className="me-2 back-arrow m-0 " color="black" />
              <i className="icon-dashboard"></i>
              <h3 className="mb-0 fw-normal">Dashboard </h3>
            </Link>
          </div>

          <div className="col-xl-auto manage-building-btn col-md-8 d-flex flex-wrap text-end justify-content-start justify-content-md-end">
            {designation !== "Admin" && (
              <Link
                to={
                  makeUrl.apiUrl == "request"
                    ? `/addtask/${managerId}`
                    : designation == "Owner" || designation == "Partner"
                    ? `/add${makeUrl.apiUrl}/${managerId}`
                    : `/${designation.toLowerCase()}/add${
                        makeUrl.apiUrl
                      }/${managerId}`
                }
                // to={`/add${makeUrl.apiUrl}/${managerId}`}
                className="btn btn-outline-primary me-2 mb-2 d-flex align-items-center"
              >
                Edit
                <FaPen className="edit-pen ms-3" />
              </Link>
            )}

            <Link
              to={
                makeUrl.apiUrl == "request"
                  ? `/addtask/${managerId}`
                  : designation == "Owner" || designation == "Partner"
                  ? `/${makeUrl.apiUrl}list`
                  : `/${designation.toLowerCase()}/${makeUrl.apiUrl}list`
              }
              // to={`/${makeUrl.apiUrl}list`}
              className="btn btn-outline-primary mb-2 ms-lg-2 ms-xl-0"
            >
              Back To {makeUrl.apiUrl} List
            </Link>
          </div>
        </div>

        <section className="row d-flex justfy-content-between mt-lg-5 mt-md-3 mt-2 mb-4">
          <div className="col-xl-7 left manager-details-area col-md-7 col-lg-7">
            <h2 className="heading-text">
              {profileData.first_name} {profileData.last_name}
            </h2>

            <ul className="d-flex flex-wrap mt-4">
              <li>
                <span>Username :</span>
                <p> {profileData?.username} </p>
              </li>
              <li>
                <span>Name :</span>
                <p>
                  {profileData?.first_name +
                    "   " +
                    profileData?.middle_name +
                    " " +
                    profileData?.last_name}
                </p>
              </li>

              <li>
                <span>Phone :</span>
                <p>{profileData?.phone_number}</p>
              </li>

              <li>
                <span>Email ID :</span>
                <p>{profileData?.email}</p>
              </li>

              <li>
                <span>Street Address :</span>
                <p>{profileData?.address}</p>
              </li>

              <li>
                <span>Apartment, Suite :</span>
                <p>{profileData?.apartment}</p>
              </li>

              <li>
                <span>Country :</span>
                <p>{profileData?.country_name}</p>
              </li>
              <li>
                <span>Province :</span>
                <p>{profileData?.province_name}</p>
              </li>

              <li>
                <span>City :</span>
                <p>{profileData?.city}</p>
              </li>

              <li>
                <span>Post Code :</span>
                <p>{profileData?.postal_code}</p>
              </li>
            </ul>
          </div>

          <div className="right profile-details col-md-5 col-lg-5 d-flex flex-column align-items-end">
            <div className="area-hide add-building-img">
              <div className="image-area d-flex align-items-center justify-content-center position-relative">
                <img
                  id="show-image"
                  src={
                    profileData?.profile_image
                      ? profileData?.profile_image
                      : DummyImg
                  }
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>

        {(makeUrl.apiUrl == "worker" || makeUrl.apiUrl == "manager") && (
          <>
            <hr
              className="w-100 mb-1"
              //    style={"border: 1px solid #E5E5E5"}
            />

            <div className="list-data">
              <h1 className="heading-text mb-2 mb-md-4 mt-5">
                {makeUrl.apiUrl == "worker"
                  ? "All Task"
                  : "Buildings Associated With"}
              </h1>

              {makeUrl.apiUrl !== "manager" && (
                <div className="data-filters d-flex justify-content-between align-items-center mb-4">
                  <div className="page-records d-flex align-items-center">
                    <form action="" className="number">
                      <select
                        className="number-box"
                        value={record}
                        name="record"
                        onChange={(event) => {
                          setRecord(event.target.value);
                          setPages(1);
                        }}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                      </select>
                    </form>
                    <h3 className="mb-0 ms-2 d-none d-sm-block">
                      Records Per Page
                    </h3>
                  </div>
                </div>
              )}
            </div>

            <section className="mb-2 mb-md-4">
              <div className="overflow-auto table-content">
                <table className=" w-100">
                  <thead>
                    <tr>
                      {tableNameData?.map((t) => (
                        <th key={t} className="">
                          {t}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {loading ? (
                    <Loader />
                  ) : (
                    <tbody>
                      {showListData?.length > 0 ? (
                        showListData?.map((list, i) => {
                          return (
                            <tr key={i}>
                              <td className="text-center">
                                {pages > 1
                                  ? record * (pages - 1) + i + 1
                                  : i + 1}
                              </td>
                              {tableValueData?.map((item, index) => (
                                <td
                                  style={
                                    tableValueData[index] ==
                                      "receiver_status" ||
                                    tableValueData[index] == "priority"
                                      ? {
                                          color:
                                            list[tableValueData[index]] ==
                                              "In Progress" ||
                                            list[tableValueData[index]] ==
                                              "Normal"
                                              ? "orange"
                                              : list[tableValueData[index]] ==
                                                  "Pending" ||
                                                list[tableValueData[index]] ==
                                                  "High"
                                              ? "red"
                                              : "green",
                                        }
                                      : { color: "" }
                                  }
                                >
                                  {tableValueData[index] == "status"
                                    ? list[tableValueData[index]] == true
                                      ? "Active"
                                      : "Inactive"
                                    : tableValueData[index] == "deadline"
                                    ? moment(
                                        list[tableValueData[index]]
                                      ).format("L")
                                    : list[tableValueData[index]]}
                                </td>
                              ))}

                              <td>
                                <ul className="table-icon d-flex justify-content-center">
                                  <li>
                                    {designation !== "Admin" && (
                                      <Link
                                        to={
                                          makeUrl.apiUrl == "worker"
                                            ? designation == "Owner" ||
                                              designation == "Partner"
                                              ? `/task-details/${list?.id}`
                                              : `/${designation.toLowerCase()}/task-details/${
                                                  list.id
                                                }`
                                            : designation == "Owner" ||
                                              designation == "Partner"
                                            ? `/building-details/${list?.id}`
                                            : `/${designation.toLowerCase()}/building-details/${
                                                list.id
                                              }`
                                        }
                                      >
                                        <FaEye
                                          className="view-icon"
                                          color="black"
                                        />
                                      </Link>
                                    )}
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">
                            {makeUrl.apiUrl == "worker"
                              ? "No task"
                              : "No Buildings Associated With Manager"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </div>
            </section>
            {Count > 5 && totallength.length > 1 ? (
              <div className="table_bottom d-flex align-items-center justify-content-end mt-5 pageNumbers">
                <button
                  onClick={handlePrevbtn}
                  disabled={pages == 1 ? true : false}
                >
                  <GrFormPrevious className="pagebutton" color="#bebebe" />
                </button>
                <ul className="d-flex">{PageShowFunc}</ul>
                <button
                  onClick={handleNextbtn}
                  disabled={pages == PageShowFunc.length ? true : false}
                >
                  <GrFormNext className="pagebutton" color="#bebebe" />
                </button>
              </div>
            ) : null}
            {isModal && (
              <div className="managermodal">
                <div className="modal-dialog modal-dialog-centered add-building-modal">
                  <div className="modal-content building-content">
                    <div className="modal-top">
                      <div className="d-flex justify-content-between align-items-center">
                        <h3 className="heading-text">Select Building </h3>

                        <Link to="" className="modal-close-button">
                          <AiFillCloseCircle
                            className="fs-4 ms-2 ms-md-4"
                            color="#000"
                            onClick={() => {
                              setIsmodal(false);
                            }}
                          />
                        </Link>
                      </div>

                      <div className="">
                        <div className="buttons d-flex align-items-center">
                          <div className="form search-bar1 modal-searchbar w-100">
                            <input
                              type="search"
                              className="form-control search-new"
                              placeholder="Search Building "
                              aria-label="search"
                              aria-describedby="search"
                              name="buildingSearch"
                              value={buildingSearch}
                              onChange={(e) =>
                                setSearchBuilding(e.target.value)
                              }
                            />
                            <button
                              className="search-btn"
                              onClick={(e) => SearchBuilding(e)}
                              type="submit"
                            >
                              <FaSearch className="m-0" color="#bebebe" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ul className="modal-list">
                      {buildingData?.length > 0 ? (
                        <>
                          {buildingData?.map((items, i) => {
                            return (
                              <li
                                className="d-flex justify-content-between align-items-center"
                                key={i}
                              >
                                <div>
                                  <p>{items.buliding_name}</p>
                                  <span>{items.buliding_code}</span>
                                </div>

                                <div className="check-btn">
                                  <input
                                    type="checkbox"
                                    name="getbuildingvalue"
                                    id={`abc${items.id}`}
                                    style={{ display: "none" }}
                                    value={items.id}
                                    defaultChecked={selectbuilding?.includes(
                                      toNumber(items.id)
                                    )}
                                    onChange={(e) => {
                                      BuildingAssignData(e);
                                      setGetbuildingvalue(e.target.value);
                                    }}
                                  />
                                  <label
                                    className="modal-choose"
                                    htmlFor={`abc${items.id}`}
                                  >
                                    Choose
                                  </label>
                                </div>
                              </li>
                            );
                          })}
                        </>
                      ) : (
                        <div className="align-items-center empty-list">
                          <h1>No Building List</h1>
                        </div>
                      )}
                    </ul>
                    {errorMessage && (
                      <div
                        className="error error-message text-center"
                        style={{ color: "red" }}
                      >
                        {errorMessage}
                      </div>
                    )}
                    <div className="d-flex justify-content-between align-items-center modalbtn-area">
                      <button
                        className="form-btn btn-primary ml-auto"
                        disabled={managerId?.length > 0 ? false : true}
                        onClick={(e) => {
                          BuildingAssignFunc(e);
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </DashboardLayouts>
    </>
  );
}
